import React, { useContext, useRef } from "react";
import styles from "./BurgerMenu.module.scss";
import { AppContext } from "../GlobalContext";
import classNames from "classnames";
import { Link } from "react-router-dom";

import home from "../static/burger/bxs_home.svg";
import invoices from "../static/burger/iconamoon_invoice-fill.svg";
import services from "../static/burger/mdi_car.svg";
import users from "../static/burger/mdi_users.svg";
import transactions from "../static/burger/mingcute_transfer-3-fill.svg";
import useOnClickOutside from "./hooks/useOnClickOutside";

const BURGER_MENU_ITEMS = [
  {
    path: "/",
    icon: home,
    label: "Home",
  },
  {
    path: "/services",
    icon: services,
    label: "Services",
  },
  {
    path: "/users",
    icon: users,
    label: "Users",
  },
  {
    path: "/transactions",
    icon: transactions,
    label: "Transactions",
  }
];

function BurgerMenu() {
  const { openBurger: a } = useContext(AppContext);
  const [openBurger, setOpenBurger] = a;

  const burgerRef = useRef(null);

  useOnClickOutside(burgerRef, () => setOpenBurger(false), "burger-button-id");

  return (
    <div
      ref={burgerRef}
      className={classNames(styles.navbar, {
        [styles.menuActive]: openBurger,
      })}>
      <div className={styles.itemsWrap}>
        {BURGER_MENU_ITEMS.map((item) => (
          <Link onClick={() => setOpenBurger(false)} to={item.path} className={styles.menuItem}>
            <img alt="menu icon" src={item.icon} />
            {item.label}
          </Link>
        ))}
      </div>
    </div>
  );
}

export default BurgerMenu;
